export default function MainProvider({ children }) {
  return <>{children}</>;
}

